import React from "react";
import { Link, useLocation } from "react-router-dom";
import EventProfileSidebarItem from "./EventProfileSidebarNav"

const EventProfileSidebar = () => {
    const location = useLocation();
    const sidebarItems = EventProfileSidebarItem();

    const getLinkStyle = (path) => ({
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
        height: "50px",
        width: "100%",
        background: location?.pathname?.startsWith(path) ? "#e6f0fa" : "#fff",
        color: "#1E1F24",
        border: "none",
        fontWeight: 500,
        fontSize: "14px",
        transition: "background 0.2s",
        cursor: "pointer",
        // marginBottom: "5px"

    });

    return (
        <nav className="profile-navBar">
            {sidebarItems.map(item => (
                <Link key={item.path} to={item.path} style={getLinkStyle(item.path)}>
                    {typeof item.icon === "string" ? (
                        <img src={item.icon} alt={item.label} className="profile-navBar-img" />
                    ) : (
                        <div className="profile-navBar-img">{item.icon}</div>
                    )}

                    <span className="profile-navBar-item">
                        {item.label}
                    </span>
                </Link>
            ))}
            <style>{`
                .profile-navBar{
                    width: 100%,
                    min-width: 70px,
                    background: #fff,
                    border-right: 1px solid #e5e7eb,
                    padding: 0,
                }
                .profile-navBar-img{
                    width: 28px; 
                    margin-left: 15px;
                }
                .profile-navBar-item{
                    font-family: Hind;
                    font-weight: 400;
                    font-size: 15px;
                    line-height: 100%;
                    color: #1E1F24;
                    margin-left: 10px;
                }
            `}</style>
        </nav>
    );
};

export default EventProfileSidebar;